import { createApiRef } from '@backstage/core-plugin-api';

export interface Branch {
  name: string;
  date: string;
}

export interface KnowledgeGraphApi {
  getViewerUrl(repo: string, path: string, ref: string): Promise<string>;
  getBranches(repo: string): Promise<Branch[]>;
  getPaths(repo: string, ref: string): Promise<string[]>;
}

export const knowledgeGraphApiRef = createApiRef<KnowledgeGraphApi>({
  id: 'plugin.knowledge-graph.api',
});
